export const ArithmeticChoice = {
  Multi1To10: "Multi1To10",
  Addition1To10: "Addition1To10",
  Addition1To100: "Addition1To100",
  Subtraction1To10: "Subtraction1To10",
  Subtraction1To100: "Subtraction1To100"
};
